export const delimiter = new RegExp('\\r?\\n|[,|]'); // regexp to split a delimiter string by "|", "\r\n", "\n", and ",".
